import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { IntegerQueryItemDto } from 'src/core/models/query/integer-query-item.dto';
import { QueryEditorBase } from 'src/core/models/query/query-editor-base';
import { GenericLookupTypeService } from 'src/core/services/generic-lookup-type/generic-lookup-type.service';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { ConclusionSentimentStatus } from 'src/core/models/generic-lookup-type/conversation/conclusion-sentiment-status.glt';

@Component({
    selector: 'ca-query-tree-node-agreement-status',
    templateUrl: './query-tree-node-agreement-status.component.html',
    styleUrls: ['./query-tree-node-agreement-status.component.scss'],
    standalone: false
})
export class QueryTreeNodeAgreementStatusComponent extends QueryEditorBase implements OnInit {
  agreementStatuses$: Observable<GenericLookupDto[]>;
  currentStatus: string;

  payload: IntegerQueryItemDto;

  constructor(private store: Store, private genericLookupService: GenericLookupTypeService) {
    super();

    this.agreementStatuses$ = this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(ConclusionSentimentStatus)));
  }

  valueChanged() {
    this.node.isDirty = true;
    this.payload.genericLookupCode = this.genericLookupService.findGenericLookupWithId(
      this.payload.value
    )?.code;
  }

  ngOnInit(): void {
    this.payload = this.node.categoryItem.payload as IntegerQueryItemDto;
    this.agreementStatuses$.subscribe((statusList: GenericLookupDto[]) => {
      this.currentStatus = statusList.find(item => item.id === this.payload.value).code;
      this.payload.genericLookupCode = this.currentStatus;
    });

    this.node.validationStatus = true;
  }

  getOptionIcon(code: string) {
    let icon = '';
    if (code?.includes('Agreed')) {
      icon = 'far fa-handshake-alt';
    } else if (code?.includes('Disagreed')) {
      icon = 'far fa-handshake-alt-slash';
    } else icon = 'fa fa-question-circle-o';
    return icon;
  }
}

